import { useState } from 'react';
import { RevealStage } from '../RevealStage';
import { SleekButton } from '../../theme';

type Props = {
  nextPackCta: string;
  /** The CTA closes the reveal ("Done") — skinned as a secondary button. */
  nextPackIsDone: boolean;
  onOpenNextPack: () => void;
  /** The card is still in the player's hands with nothing to sell it for:
   *  they keep it (Vault) before the next pack, as with a sellable card. */
  mustVault: boolean;
  onVault?: () => void;
  visible: boolean;
  instant: boolean;
};

/** Sleek winner bottom when there is no buyback offer: Vault first while the
 *  card is unresolved (no skipping a pack's choice), then the forward CTA —
 *  straight away on a returning view of a card already sold. */
export function SleekNextPackPanel({
  nextPackCta,
  nextPackIsDone,
  onOpenNextPack,
  mustVault,
  onVault,
  visible,
  instant,
}: Props) {
  const [isVaulted, setIsVaulted] = useState(false);
  const awaitsVault = mustVault && !isVaulted;
  return (
    <RevealStage visible={visible} instant={instant} className="mt-auto flex w-full max-w-[480px] mx-auto gap-3">
      {awaitsVault ? (
        <SleekButton
          name="RevealVaultButton"
          onClick={() => {
            setIsVaulted(true);
            onVault?.();
          }}
          className="flex-1"
        >
          Vault
        </SleekButton>
      ) : (
        <SleekButton name={nextPackIsDone ? 'RevealDoneButton' : 'RevealNextPackButton'} onClick={onOpenNextPack} className="flex-1">
          {nextPackCta}
        </SleekButton>
      )}
    </RevealStage>
  );
}
